import { IHisInfoGroupBehavior } from ".";
import { HisInformationItem, HisInformationListItem } from "../..";
import { IHisInformationApplicable } from "../../../document/items";

export class HisInfoListItemBehavior implements IHisInfoGroupBehavior {
  constructor(private source: IHisInformationApplicable, private hisInfoListItems: HisInformationListItem[]) {
  }

  createHisInfoItems(): HisInformationItem[] {
    if (this.hisInfoListItems === null) { return [ new HisInformationItem(this.source.hisItemParameter.key, "") ]; }
    
    const items = this.hisInfoListItems.map(x => x.items).reduce((p, c) => p.concat(c), []);
    return items;
  }

  areSameGroup(item: IHisInformationApplicable): boolean {
    return item.hisItemParameter.informationKind === this.source.hisItemParameter.informationKind;
  }
}
